export const canManageApprovers = (user, formName) => {
    if (!user) return false;

    // 1. Check if user is an admin (Admins bypass permission checks)
    const isAdmin = user.roles?.some(role => role.name === 'admin' || role.name === 'Admin' || role.name === 'super-admin') || user.roles?.includes('admin');
    if (isAdmin) return true;

    // 2. Build the dynamic permission string
    const requiredPermission = `Workflow-${formName}-edit`;

    // 3. Check direct permissions (if they exist)
    const hasDirectPermission = user.permissions?.includes(requiredPermission);

    // 4. Check permissions assigned via roles
    const rolesPermissions = user.roles_permission || user["roles.permission"] || [];
    const hasRolePermission = rolesPermissions.some(
        permission => permission.name === requiredPermission || permission.name.toLowerCase() === requiredPermission.toLowerCase()
    );

    return hasDirectPermission || hasRolePermission;
};

export const getFormNameById = (formId) => {
    const map = {
        1: 'QualityAssurance',
        2: 'SCRF',
        3: 'Deployment',
        4: 'CRF',
        5: 'MobileRequisition',
        6: 'MasterDataManagementForm',
        7: 'SapAccessForm',
        8: 'RequestSupportForm',
        9: 'UserAccessForm',
        10: 'InfraChangeRequestForm',
    };
    return map[formId] || null;
};
